export enum Wraps {
    noWrap = 'nowrap',
    wrap = 'wrap',
    wrapReverse = 'wrap-reverse',
}
